import { moduleNamespace, routeNamespace } from '@Store/config.store';

export const addNamespace = (action: string) => moduleNamespace + '/' + action;
export const addRouteNamespace = (route: string) =>
  routeNamespace + '/' + route;
